import { useSelector } from "react-redux";

export function usePermissions() {
  const privileges = useSelector(
    (state) => state?.privilegesReducer?.rbacPrivileges,
  );
  function hasPermission(permission, eitherOr) {
    if (eitherOr === "eitherOr") {
      return permission.some((p) => privileges.includes(p));
    }
    return permission.every((p) => privileges.includes(p));
  }

  return { hasPermission, privileges };
}
